var handleToArray = function handleToArray(handle) {
  return handle.split(',').map(function (hand) {
    return "".concat(hand.trim(' '));
  });
};

export default handleToArray;